import { useEffect, useState } from 'preact/hooks'
import { saveDispatcher } from '../utils.js'
import ActionCard from './ActionCard'
import Submit from './Submit.jsx'
import Footer from './Footer'
import Alert from './Alert.jsx'

export function App() {
  const [status, setStatus] = useState({})
  const [showAlert, setShowAlert] = useState(false)

  useEffect(() => {
    saveDispatcher.saveCallback = data => {
      console.log('💾 Form data changed', data)
      dispatchEvent(new CustomEvent('actioncard-change', { detail: data }))
    }
  }, [])

  useEffect(() => {
    if (status.text) {
      setShowAlert(true)
      if (status.type !== 'error') {
        const timer = setTimeout(() => {
          setShowAlert(false)
        }, 3000) // Hide non-error alert after 3 seconds
        return () => clearTimeout(timer)
      }
    }
  }, [status])

  return (
    <div className="flex flex-col h-screen dark:bg-[#151515]">
      <div className="flex-1 overflow-auto">
        <ActionCard />
      </div>

      <Submit setStatus={setStatus} />

      <div className="mt-2">
        <Footer />
      </div>

      <div
        className={`
          transition-transform duration-500 ease-in-out 
          transform fixed bottom-0 left-0 right-0
          ${showAlert ? 'translate-y-0' : 'translate-y-full'} 
        `}
      >
        <Alert message={status.text} type={status.type} setShowAlert={setShowAlert} />
      </div>
    </div>
  )
}
